import React, { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';

interface ToggleSwitchProps {
  leftOption: string;
  rightOption: string;
  defaultOption?: string;
  onChange?: (selected: string) => void;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  leftOption,
  rightOption,
  defaultOption,
  onChange,
}) => {
  const [selected, setSelected] = useState<string>(defaultOption || leftOption);

  const handleToggle = (option: string, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    setSelected(option);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <Flex
      bg="#1A202C"
      borderRadius="full"
      width="fit-content"
      alignItems="center"
      onClick={(e) => e.stopPropagation()}
    >
      <Box
        as="button"
        py="6px"
        px="16px"
        borderRadius="full"
        bg={selected === leftOption ? '#2D3748' : 'transparent'}
        color={selected === leftOption ? 'gray.200' : 'gray.600'}
        onClick={(e: React.MouseEvent<Element, MouseEvent>) => handleToggle(leftOption, e)}
        fontWeight="bold"
        transition="all 0.2s"
        aria-pressed={selected === leftOption}
        role="button"
        _hover={{
          bg: selected === leftOption ? '#2D3748' : 'rgba(255, 255, 255, 0.06)',
        }}
        fontSize="sm"
      >
        {leftOption}
      </Box>
      <Box
        as="button"
        py="6px"
        px="16px"
        borderRadius="full"
        bg={selected === rightOption ? '#2D3748' : 'transparent'}
        color={selected === rightOption ? 'gray.200' : 'gray.600'}
        onClick={(e: React.MouseEvent<Element, MouseEvent>) => handleToggle(rightOption, e)}
        fontWeight="bold"
        transition="all 0.2s"
        aria-pressed={selected === rightOption}
        role="button"
        _hover={{
          bg: selected === rightOption ? '#2D3748' : 'rgba(255, 255, 255, 0.06)',
        }}
        fontSize="sm"
      >
        {rightOption}
      </Box>
    </Flex>
  );
};
